import React, { useState } from "react";
import { API_ROOT, webPath } from "../apiConfig";

const Unsubscribe = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // 'success' or 'error'

  const handleUnsubscribe = async () => {
    setMessage(""); // Clear previous message
    setMessageType("");

      try {
      
      const response = await fetch(
        `${API_ROOT}/api/subscribe/unsubscribe`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        },
      );

      const data = await response.json();

      if (response.ok) {
        setMessage("User unsubscribed successfully");
        setEmail("");
        setMessageType("success");
      } else {
        setMessage(data.error || "Failed to unsubscribe.");
        setMessageType("error");
      }
    } catch (error) {
      setMessage("An error occurred. Please try again.");
      setMessageType("error");
    }
  };

  console.log("messageType :", messageType);
  return (
    <div className="bg-white">
      <div className="container container-max">
        <div className="row">
          <div className="col-md-12 mb-5 mt-5 justify-content-center align-items-center d-flex">
            <div className="card unsubBox col-md-4 mt-5 mb-5 border p-3 bg-black">
              <h3 className="fw-bold h3 mb-3 text-white">Unsubscribe</h3>

              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                style={{ borderRadius: "6px", border: "1px solid #cdcdcd" }}
                className="py-2 mb-2 form-control text-black"
              />
              <label className="mb-3 text-white">Email Address *</label>

              <button
                className="unSubBtn"
                onClick={handleUnsubscribe}
              >
                Unsubscribe
              </button>

              {message && (
                <p
                  className="mt-3 text-success"
                  style={{
                    fontWeight: 500,
                    color: messageType === "success" ? "green" : "red",
                  }}
                >
                  {message}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unsubscribe;
